import React, { createContext, useContext, useState } from 'react';
import { api } from 'app';

const SlidersUIContext = createContext();

export function useSlidersUIContext() {
  return useContext(SlidersUIContext);
}

export function SlidersUIProvider({ children }) {
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);

  const fetchData = async query => {
    const q = query.slice(1);
    api
      .get(`/adminPanel/sliders?include=event&${q}`)
      .then(response => {
        setData(response);
      })
      .catch(err => {
        console.log(err);
      });
  };

  const value = {
    fetchData,
    data,
    setData,
    isLoading,
    setIsLoading
  };

  return <SlidersUIContext.Provider value={value}>{children}</SlidersUIContext.Provider>;
}
